import { render, staticRenderFns } from "./hot.vue?vue&type=template&id=3695d2d6&scoped=true&"
import script from "./hot.vue?vue&type=script&lang=js&"
export * from "./hot.vue?vue&type=script&lang=js&"
import style0 from "./hot.vue?vue&type=style&index=0&id=3695d2d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695d2d6",
  null
  
)

export default component.exports